import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutProductBookTable extends Layout {
    sourceLocationCommodity: DataSource;
    tableProductBook: Table;
}
